import { render, staticRenderFns } from "./ApplicantWiseList.vue?vue&type=template&id=9a486a62&"
import script from "./ApplicantWiseList.vue?vue&type=script&lang=js&"
export * from "./ApplicantWiseList.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantWiseList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports